module.exports = __webpack_public_path__ + "img/1440.788fad0f.jpg";